// src/api.js
// Dev → localhost; Prod → fixed backend URL (Render).
// This avoids env var mismatches breaking the app.

const isLocal =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const DEV_BASE = 'http://localhost:5001';
const PROD_BASE = 'https://release-management-backend.onrender.com'; // your live backend

const BASE = isLocal ? DEV_BASE : PROD_BASE;

// Optional: log once to confirm in console after deploy
// console.log('[api] BASE =', BASE);

export function api(path, options = {}) {
  return fetch(`${BASE}${path}`, options);
}

export const API_BASE = BASE;